import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Fitness = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="fitness"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 27h22v6H19v-6zM53.687 40.908c.724 0 1.313-.59 1.313-1.314V20.406c0-.724-.59-1.314-1.313-1.314H49.63v21.816h4.056z" />
      <path d="M45.031 46.084a1.65 1.65 0 001.647-1.648V15.563a1.65 1.65 0 00-1.647-1.647h-5.569a1.65 1.65 0 00-1.647 1.647v28.874a1.65 1.65 0 001.647 1.647h5.569zM10.37 40.908V19.092H6.313c-.725 0-1.314.59-1.314 1.314v19.188c0 .725.59 1.314 1.314 1.314h4.055zM22.186 15.563a1.65 1.65 0 00-1.648-1.647h-5.569a1.65 1.65 0 00-1.647 1.647v28.874c0 .908.739 1.647 1.647 1.647h5.569a1.65 1.65 0 001.648-1.648V15.564z" />
    </svg>
  );
};
/* eslint-enable max-len */

Fitness.defaultProps = {
  className: null,
};

Fitness.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Fitness;
